import { DependsOnIfEnum, DependsOnThenEnum } from "@cak-legacy/generation-schema-core";
import { Field } from "../interface/SimpleForm/Field";
import { PredefinedField } from "../interface/SimpleForm/PredefinedField";
import { PredefinedFieldType } from "../interface/SimpleForm/PredefinedFieldType";

export const GetAdresFieldSet = (
  fieldNamePrefix: string = "",
  isRequired: boolean = true
): { [fieldName: string]: PredefinedField } => {
  let straatFieldName = `straat`;
  let huisnummerFieldName = `huisnummer`;
  let postcodeFieldName = `postcode`;
  let plaatsFieldName = `plaats`;
  let landFieldName = `land`;

  if (fieldNamePrefix) {
    straatFieldName = `${fieldNamePrefix}Straat`;
    huisnummerFieldName = `${fieldNamePrefix}Huisnummer`;
    postcodeFieldName = `${fieldNamePrefix}Postcode`;
    plaatsFieldName = `${fieldNamePrefix}Plaats`;
    landFieldName = `${fieldNamePrefix}Land`;
  }
  const set: { [fieldName: string]: PredefinedField } = {};

  set[straatFieldName] = {
    predefinedFieldType: PredefinedFieldType.straat,
    isRequired: isRequired
  };

  set[huisnummerFieldName] = {
    predefinedFieldType: PredefinedFieldType.huisnummer,
    isRequired: isRequired
  };

  set[postcodeFieldName] = {
    predefinedFieldType: PredefinedFieldType.postcode,
    isRequired: isRequired
  };

  set[plaatsFieldName] = {
    predefinedFieldType: PredefinedFieldType.plaats,
    isRequired: isRequired
  };

  set[landFieldName] = {
    predefinedFieldType: PredefinedFieldType.land,
    isRequired: isRequired
  };

  return set;
};

export const GetForeignAddressFieldSet = (
  fieldNamePrefix: string = "",
  isRequired: boolean = true
): { [fieldName: string]: PredefinedField } => {
  let addressLine1 = `adresRegel1`;
  let addressLine2 = `adresRegel2`;
  let huisnummerFieldName = `huisnummer`;
  let postcodeFieldName = `postcode`;
  let plaatsFieldName = `plaats`;
  let provincieFieldName = `provincie`;
  let landFieldName = `land`;

  if (fieldNamePrefix) {
    addressLine1 = `${fieldNamePrefix}AdresRegel1`;
    addressLine2 = `${fieldNamePrefix}AdresRegel2`;
    huisnummerFieldName = `${fieldNamePrefix}Huisnummer`;
    postcodeFieldName = `${fieldNamePrefix}Postcode`;
    plaatsFieldName = `${fieldNamePrefix}Plaats`;
    provincieFieldName = `${fieldNamePrefix}Provincie`;
    landFieldName = `${fieldNamePrefix}Land`;
  }
  const set: { [fieldName: string]: PredefinedField } = {};

  set[addressLine1] = {
    predefinedFieldType: PredefinedFieldType.adresRegel,
    isRequired: isRequired
  };

  set[addressLine2] = {
    predefinedFieldType: PredefinedFieldType.adresRegel
  };

  set[huisnummerFieldName] = {
    predefinedFieldType: PredefinedFieldType.huisnummer,
    isRequired: isRequired
  };

  set[postcodeFieldName] = {
    predefinedFieldType: PredefinedFieldType.postcode
  };

  set[plaatsFieldName] = {
    predefinedFieldType: PredefinedFieldType.plaats,
    isRequired: isRequired
  };

  set[provincieFieldName] = {
    predefinedFieldType: PredefinedFieldType.provincie
  };

  set[landFieldName] = {
    predefinedFieldType: PredefinedFieldType.land,
    isRequired: isRequired
  };

  return set;
};

export const GetRekeningnummerFieldSet = (
  fieldNamePrefix: string = "",
  isRequired: boolean = true
): { [fieldName: string]: Field } => {
  let rekeningnummerName = "rekeningnummer";
  let bicName = "bic";

  if (fieldNamePrefix) {
    rekeningnummerName = `${fieldNamePrefix}Rekeningnummer`;
    bicName = `${fieldNamePrefix}Bic`;
  }

  const set: { [fieldName: string]: Field } = {};
  set[rekeningnummerName] = {
    predefinedFieldType: PredefinedFieldType.iban,
    isRequired: isRequired
  };

  set[bicName] = {
    type: "text",

    ui: {
      flexDirection: "column"
    },
    showIsValidCheckmark: true,
    validate: {
      isRequired: {
        value: isRequired
      },
      regex: {
        value: "^[a-zA-Z0-9]{8,11}$"
      }
    },
    dependsOn: [
      {
        if: DependsOnIfEnum.StartsWith,
        property: rekeningnummerName,
        value: "NL",
        isAbsolutePath: false,
        then: DependsOnThenEnum.Hide
      },
      {
        if: DependsOnIfEnum.IsEqualToValue,
        property: rekeningnummerName,
        value: "N",
        isAbsolutePath: false,
        then: DependsOnThenEnum.Hide
      },
      {
        if: DependsOnIfEnum.IsEqualToValue,
        property: rekeningnummerName,
        value: "n",
        isAbsolutePath: false,
        then: DependsOnThenEnum.Hide
      },
      {
        if: DependsOnIfEnum.IsNotGiven,
        property: rekeningnummerName,
        isAbsolutePath: false,
        then: DependsOnThenEnum.Hide
      }
    ]
  };

  return set;
};
